<template>
  <div class="form-v1">
    <slot name="title" v-if="title">
      <h2 class="dark-orange--text font30 p-flex">{{title}}</h2>
    </slot>
    <slot name="pre_form"><!--  v-bind="{item,expanded,expand,is_expanded:is_expanded(item)}" -->
    </slot>

    <v-layout wrap>
      <template v-for="(item,i) in scheme_list">
        <slot :name="item.k" v-bind="{selectedItem,item_info:item}">
          <in-text-area v-if="item.type=='string' && item.comp == 'in-text-area'" v-model="selectedItem[item.k]" :label="item.label" :md="item.md||4" :view_only="read_only" :class="item.class" :optional="!item.notNull">
          </in-text-area>
          <in-text v-else-if="item.type=='string'" :key="`${i}`" v-model="selectedItem[item.k]" :label="item.label" :md="item.md||4" :view_only="read_only" :class="item.class" :optional="!item.notNull"/>
          <in-num v-else-if="item.type=='number'" :key="`${i}`" v-model="selectedItem[item.k]" :label="item.label" :md="item.md||4" :view_only="read_only" :class="item.class" :optional="!item.notNull"/>
          <in-calendar v-else-if="item.type=='date'" :key="`${i}`" :date.sync="selectedItem[item.k]" :label="item.label" :md="item.md||4" :required="true" :view_only="read_only" :class="item.class" :optional="!item.notNull"/>
          <value-container v-else-if="item.type=='read_only'" :key="`${i}`" :value="selectedItem[item.k] || c_read_only_item[item.k]" :label="item.label" :md="item.md||4" :class="item.class"/>
          <v-col v-else :key="`${i}`" :cols="item.md||4" class="flex" :class="item.class"><!--type no definidos   -->
            <slot :name="`col-${item.k}`" v-bind="{selectedItem,item_info:item,read_only}"></slot>
          </v-col>
        </slot>
        <template v-if="after_slot[item.k]">
          <v-col :key="after_slot[item.k].name" :cols="after_slot[item.k].md" class="flex" :class="after_slot[item.k].class" :style="after_slot[item.k].style">
            <slot :name="after_slot[item.k].name" v-bind="{selectedItem,item_info:item}"></slot>
          </v-col>
        </template>
      </template>
    </v-layout>

  </div>
</template>

<script>
export default {
  mixins: [ ],
  props:{
    c_read_only_item:{default:()=>{return{}}},
    selectedItem:{default:()=>{return{}}},
    scheme:{default:()=>{return{}}},
    read_only:{default:false},
    after_slot:{default:()=>{return{}}},
    title:{default:null},
  },
  data() {
    return {

    };
  },
  computed: {
    scheme_list(){
      const list = [];
      Object.keys(this.scheme).forEach(k=>!this.scheme[k].hidden && list.push(Object.assign({k},this.scheme[k])));
      return list;
    }
  },
  watch:{ },
  methods: {

  },
};
</script>
